import {
  Checkbox,
  FormControl,
  FormHelperText,
  SxProps,
  Theme,
} from '@mui/material';
import React, { useMemo } from 'react';
import { FieldErrors, RegisterOptions, useFormContext } from 'react-hook-form';

type CheckBoxKitProps = {
  name: string;
  disabled?: boolean;
  validation?: RegisterOptions;
  sxStyle?: SxProps<Theme>;
};

export const CheckBoxKit = ({
  name,
  disabled = false,
  validation,
  sxStyle,
}: CheckBoxKitProps) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();
  const error = errors[name]?.message ? true : false;

  const checkErrorType = useMemo(() => {
    if (errors[name]?.type === 'required') {
      return true;
    }

    if (errors[name]?.type === 'validate') {
      return true;
    }

    return false;
  }, [errors]);

  return (
    <FormControl error={error} required={checkErrorType}>
      <Checkbox
        sx={{
          ...sxStyle,
        }}
        {...register(name, {
          ...validation,
        })}
      />
    </FormControl>
  );
};
